<app-modal-header>
  <div class="flex items-center gap-4">
    <svg-icon class="h-7 w-7 text-base-ea-700" src="assets/icons/icon-video.svg"></svg-icon>
    <hr app-modal-divider />
    <p class="truncate text-lg font-medium">{{ data.name }}</p>
  </div>
</app-modal-header>

<div app-modal-content class="flex w-[80vw] items-center justify-center bg-black p-0">
  <video class="max-h-[80vh] w-full" controls autoplay [src]="data.url"></video>
</div>
